import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import ProductCard from "@/components/Product/ProductCard";
import ShopCard from "@/components/Shop/ShopCard";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { toast } from "sonner";

export default function Favorites() {
  const [products, setProducts] = useState([]);
  const [shops, setShops] = useState([]);
  const [favProductIds, setFavProductIds] = useState([]);
  const [favShopIds, setFavShopIds] = useState([]);

  const load = () => {
    api.get("/favorites").then(r => {
      setProducts(r.data?.products || []);
      setShops(r.data?.shops || []);
    });
    api.get("/favorites/ids").then(r => {
      setFavProductIds(r.data?.product_ids || []);
      setFavShopIds(r.data?.shop_ids || []);
    });
  };
  useEffect(() => { load(); }, []);

  const toggleFavProduct = async (id) => {
    const { data } = await api.post("/favorites/toggle", { target_id: id, target_type: "product" });
    if (!data.favorited) {
      setProducts(ps => ps.filter(p => p.id !== id));
      setFavProductIds(ids => ids.filter(x => x !== id));
      toast.success("Retiré des favoris");
    }
  };

  const toggleFavShop = async (id) => {
    const { data } = await api.post("/favorites/toggle", { target_id: id, target_type: "shop" });
    if (!data.favorited) {
      setShops(ss => ss.filter(s => s.id !== id));
      setFavShopIds(ids => ids.filter(x => x !== id));
      toast.success("Boutique retirée des favoris");
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-3 sm:px-6 py-4">
      <h1 className="font-[Manrope] font-bold text-xl mb-4">Mes favoris</h1>
      <Tabs defaultValue="products">
        <TabsList className="bg-[#F3F1EC] rounded-xl p-1">
          <TabsTrigger value="products" data-testid="tab-fav-products" className="rounded-lg px-4 data-[state=active]:bg-white">Produits ({products.length})</TabsTrigger>
          <TabsTrigger value="shops" data-testid="tab-fav-shops" className="rounded-lg px-4 data-[state=active]:bg-white">Boutiques ({shops.length})</TabsTrigger>
        </TabsList>
        <TabsContent value="products" className="mt-4">
          {products.length === 0 ? (
            <div className="py-10 text-center text-sm text-[#73706B]">Aucun produit favori pour l'instant</div>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
              {products.map(p => (
                <ProductCard key={p.id} product={p} onFavorite={toggleFavProduct} isFav={favProductIds.includes(p.id)} />
              ))}
            </div>
          )}
        </TabsContent>
        <TabsContent value="shops" className="mt-4">
          {shops.length === 0 ? (
            <div className="py-10 text-center text-sm text-[#73706B]">Aucune boutique favorite</div>
          ) : (
            <div className="flex gap-3 flex-wrap">
              {shops.map(s => (
                <ShopCard key={s.id} shop={s} isFav={favShopIds.includes(s.id)} onFavorite={toggleFavShop} />
              ))}
            </div>
          )}
        </TabsContent>
      </Tabs>
    </div>
  );
}
